<script lang="ts">
  import { CircleCheckBig } from "lucide-svelte"

  let { products } = $props()
</script>

<div
  class="mt-8 space-y-4 lg:space-y-0 grid grid-cols-1 sm:grid-cols-2 gap-x-3 lg:grid-cols-3 xl:gap-x-6"
>
  {#each products as plan (plan.id)}
    <div>
      <div
        class="p-4 xl:p-6 w-full rounded-lg shadow flex flex-col items-stretch {plan.id ===
        'standard'
          ? 'border-2 border-blue-400 bg-lwp-theme-blue text-white'
          : 'border border-blue-600 bg-white text-gray-900 mt-6'}"
      >
        <div class="flex-1">
          <h3 class="text-4xl font-bold">{plan.name}</h3>
          <p class="mt-4">
            {plan.description}
          </p>
          {#if plan.id === "free"}
            <div class="mt-6 flex items-baseline whitespace-nowrap">
              <span class="text-4xl font-extrabold tracking-tight">
                3 Users
              </span>
              <span class="ml-2 text-xl">/ Limited Features</span>
            </div>
          {:else if plan.id === "standard"}
            <div class="mt-6 flex items-baseline whitespace-nowrap">
              <span class="text-4xl font-extrabold tracking-tight">
                {plan.pricing.full_access.annual}
              </span>
              <span class="ml-1 text-xl">/ month / full member</span>
            </div>
            <p class="text-sm mt-2">
              {plan.pricing.full_access.annualDetail}
            </p>
            <span class="mt-2 text-sm font-semibold text-green-200"
              >You save 18% with Annual Billing</span
            >
          {/if}

          <p
            class="text-xl font-bold mt-6 {plan.id === 'standard'
              ? 'text-gray-200'
              : 'text-gray-800'}"
          >
            Includes these features & more:
          </p>
          <ul class="mt-4 space-y-4">
            {#each plan.features as feature}
              <li class="flex">
                <CircleCheckBig class="text-green-400 h-6 w-6" />

                <span class="ml-3">{feature}</span>
              </li>
            {/each}
          </ul>
        </div>
        <form
          action={plan.id === "enterprise" ? "/contact" : "/signup/new"}
          method="GET"
        >
          <input
            type="hidden"
            name="authenticity_token"
            value={document.querySelector('meta[name="csrf-token"]').content}
          />
          <input type="hidden" name="selected_plan_id" value={plan.id} />
          <button
            type="submit"
            class="bg-indigo-50 text-indigo-700 hover:bg-indigo-100 mt-8 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium"
          >
            {#if plan.id === "standard"}
              Start Free Trial
            {:else if plan.id === "enterprise"}
              Contact Us
            {:else}
              Start Now
            {/if}
          </button>
        </form>
      </div>
    </div>
  {/each}
</div>
